import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { IDetails } from 'src/app/@interfaces/details/details.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-detail-payment',
  templateUrl: './detail-payment.component.html',
  styleUrls: ['./detail-payment.component.css'],
  imports: [
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatTableModule,
    CurrencyPipe,
    DatePipe,
    TranslatePipe,
  ],
})
export class DetailPaymentComponent implements OnInit {
  @Input() details: IDetails[] = [];
  @Input() totalDSO = 0;
  @Input() totalBPDSO = 0;
  @ViewChild(MatAccordion) accordion?: MatAccordion;
  columnsNotes: string[] = ['code', 'total'];
  columnsPays: string[] = ['identifier', 'type', 'date', 'value'];
  constructor() {}

  ngOnInit(): void {}
}
